import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from "@angular/core";

@Directive({
  standalone: false,
  selector: "[fxLayoutAlign]"
})
export class FxLayoutAlignDirective implements OnChanges {
  @Input() fxLayoutAlign?: string;

  constructor(
    private readonly host: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2
  ) {}

  ngOnChanges(_: SimpleChanges): void {
    const [mainAxis = "start", crossAxis = "stretch"] = (this.fxLayoutAlign || "").trim().split(/\s+/);

    this.renderer.setStyle(this.host.nativeElement, "display", "flex");
    this.renderer.setStyle(this.host.nativeElement, "justify-content", this.mapMain(mainAxis));
    this.renderer.setStyle(this.host.nativeElement, "align-items", this.mapCross(crossAxis));
  }

  private mapMain(value: string): string {
    switch ((value || "").toLowerCase()) {
      case "center":
        return "center";
      case "end":
        return "flex-end";
      case "space-around":
        return "space-around";
      case "space-between":
        return "space-between";
      case "space-evenly":
        return "space-evenly";
      default:
        return "flex-start";
    }
  }

  private mapCross(value: string): string {
    switch ((value || "").toLowerCase()) {
      case "center":
        return "center";
      case "end":
        return "flex-end";
      case "baseline":
        return "baseline";
      case "stretch":
        return "stretch";
      default:
        return "flex-start";
    }
  }
}
